import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=53f0c8af&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=53f0c8af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0c8af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f0c8af')) {
      api.createRecord('53f0c8af', component.options)
    } else {
      api.reload('53f0c8af', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=53f0c8af&scoped=true&", function () {
      api.rerender('53f0c8af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bS5Yfld3f82Y/JS/comp/PopupBox.vue"
export default component.exports